import ReportIsGeneratedPopup from './ReportIsGeneratedPopup';

export default ReportIsGeneratedPopup;
